/**
 * 「閉じる」状態の永続化は仕様変更により撤廃済み（リロード/再来訪で再表示する仕様）。
 */

export const ROTATION_INTERVAL_MS = 5000;

export function getNextSlideIndex(current: number, total: number): number {
  if (total <= 0) return 0;
  return (current + 1) % total;
}
